/*@ngInject*/
const MultiSelectController = function ($scope, $rootScope, $timeout, coreConstant, localization) {
    let timeoutList = [];

    localization.getTranslationByKey('advancedFilter').then((translations) => {
        this.translations = translations;
        if (!this.isListLoadDynamically) {
            this.buttonLabel = this.refreshButtonLabel();
        }
    });

    this.$onInit = function () {
        this.initialize();

        this.$onChanges = function () {
            this.initialize();
        };
    };

    this.initialize = function () {
        if (_.isNil(this.delimiter)) {
            this.delimiter = '::';
        }

        this.setItemsList();
        this.refreshButtonLabel();
        if (this.autoExpand) {
            this.openMultiSelectPopup();
        }
    };

    this.setItemsList = function () {
        if (this.isListLoadDynamically) {
            if (!_.isNil(this.selectedValue)) {
                _.each(this.selectedValue, (selectedVal) => {
                    _.each(this.itemsList, (item) => {
                        if (item.code === selectedVal.code) {
                            item.selected = true;
                        }
                    });
                });

                let totalList = _.concat(this.itemsList, this.selectedValue);
                this.itemsList = _.uniqBy(totalList, 'code');
            }
        } else {
            _.each(this.itemsList, function (item) {
                item.selected = false;
            });

            _.intersectionWith(this.itemsList, _.split(this.selectedValue, this.delimiter),
                function (dataItem, criterionItem) {
                    if (dataItem.value === criterionItem) {
                        dataItem.selected = true;
                        return true;
                    } else {
                        return false;
                    }
                }
            );
        }
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, (event, itemName) => {
        if (this.itemName === itemName) {
            this.selectedValue = '';
            _.each(this.itemsList, function (item) {
                item.selected = false;
            });
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, (event, itemName) => {
        if (this.itemName === itemName) {
            if (this.isListLoadDynamically) {
                this.itemsList = _.filter(this.itemsList, function (item) {
                    return item.selected;
                });
            }

            $scope.$emit(coreConstant.event.MULTI_SELECT_CLOSED);
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, (event, itemName) => {
        if (this.itemName === itemName) {
            if (this.isListLoadDynamically) {
                this.refreshButtonLabel();
                let selectedValueList = _.filter(this.itemsList, function (item) {
                    return item.selected;
                });
                this.onChange({selectedValueList});
                this.selectedValue = selectedValueList;
            } else {
                this.refreshButtonLabel();
                this.onChange({
                    selectedValueList: _.filter(this.itemsList, function (item) {
                        return item.selected;
                    })
                });
            }
        }
    });

    this.openMultiSelectPopup = function (event) {
        $rootScope.$broadcast(coreConstant.event.SHOW_MULTI_SELECT, event, this.itemsList, this.itemName, this.appendToBody);
    };

    this.refreshButtonLabel = function () {
        const tempItemList = _.filter(this.itemsList, function (item) {
            return item.selected;
        });

        let names = '';

        if (this.isListLoadDynamically) {
            names = _.map(tempItemList, 'code');
        } else {
            names = _.map(tempItemList, 'name');
        }

        let multipleSelection = _.size(tempItemList) > 1,
            allSelected = _.size(tempItemList) === _.size(this.itemsList);
        names = _.join(names, ', ');
        this.names = names;

        if (this.truncateCharLength) {
            names = _.truncate(names, {length: this.truncateCharLength, seperator: /,? +/});
        } else {
            names = _.truncate(names, {length: 75, seperator: /,? +/});
        }

        timeoutList.push($timeout(() => {
            if (!_.isEmpty(names)) {
                if (!_.isNil(this.fixedAllSelectedButtonLabel) && allSelected) {
                    names = this.fixedAllSelectedButtonLabel;
                } else if (!_.isNil(this.fixedMultipleSelectionButtonLabel) && multipleSelection) {
                    names = this.fixedMultipleSelectionButtonLabel;
                }
            }

            this.buttonLabel = names ? names : (_.isNil(this.promptValue) ? this.translations.placeholder : this.promptValue);

            $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_BUTTON_LABEL_UPDATED, this.itemName, this.buttonLabel);
        }, 0));
    };

    this.onItemClick = function (item) {
        item.selected = !item.selected;
        this.refreshButtonLabel();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_LIST_UPDATED, (event, itemName, itemList, searchText) => {
        if (this.itemName === itemName) {
            this.itemsList = itemList;
            if (!_.isNil(searchText)) {
                this.setItemsList();
                this.refreshButtonLabel();
                $rootScope.$broadcast(coreConstant.event.SHOW_MULTI_SELECT_LIST_UPDATED, this.itemsList);
            } else {
                this.selectedValue = itemList;
                this.setItemsList();
                this.refreshButtonLabel();

            }
        }
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umCore')
    .controller('multiSelectController', MultiSelectController);
